module.exports = __webpack_public_path__ + "img/35.ce8813d8.jpg";